export default [
  { value: 0, title: 'Unprioritized', color: 'white' },
  { value: 1, title: 'Low', color: 'success' },
  { value: 2, title: 'Medium', color: 'warning' },
  { value: 3, title: 'High', color: 'error' },
]
